import api from "../api";

export const DEFAULT_COUNTRY: api.CountryEnum = "NO";
